/* eslint-disable */
import moment from 'moment';

/* Get the current instant */
const now = moment();

export const analytics = {
    visitors: {
        series: {
            'this-year': [
                {
                    name: 'Visitors',
                    data: [
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 4884,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 5351,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 5293,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 4908,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 5027,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 4837,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 4484,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 4071,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 4124,
                        },
                        {
                            x: now
                                .subtract(12, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 4563,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 3820,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 3968,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 4102,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3941,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3566,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3853,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 3853,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 4069,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3879,
                        },
                        {
                            x: now
                                .subtract(11, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 4298,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 4355,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 4065,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3650,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3379,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3191,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 2968,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2957,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3313,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3708,
                        },
                        {
                            x: now
                                .subtract(10, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3586,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 3965,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 3901,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3410,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3748,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3929,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3846,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 3771,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 4015,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3589,
                        },
                        {
                            x: now
                                .subtract(9, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3150,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 3050,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2574,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 2823,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 2848,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3000,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3216,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 3299,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3768,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3524,
                        },
                        {
                            x: now
                                .subtract(8, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3918,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 4145,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 4378,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3941,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3932,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 4380,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 4243,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 4367,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3879,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 4357,
                        },
                        {
                            x: now
                                .subtract(7, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 4181,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 4619,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 4769,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 4901,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 4640,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 5128,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 5015,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 5360,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 5608,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 5272,
                        },
                        {
                            x: now
                                .subtract(6, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 5660,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 5836,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 5659,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 5575,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 5474,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 5427,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 5865,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 5700,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 6052,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 5760,
                        },
                        {
                            x: now
                                .subtract(5, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 5648,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 5435,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 5239,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 5452,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 5416,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 5195,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 5119,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 4635,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 4833,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 4584,
                        },
                        {
                            x: now
                                .subtract(4, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 4822,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 4582,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 4348,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 4132,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 4099,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3849,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 4010,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 4486,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 4403,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 4141,
                        },
                        {
                            x: now
                                .subtract(3, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3780,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 3524,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 3212,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3568,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3800,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3796,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3870,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 3745,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3751,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3310,
                        },
                        {
                            x: now
                                .subtract(2, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3509,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 3187,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2918,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3191,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3437,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3291,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3317,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 3716,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3260,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 3694,
                        },
                        {
                            x: now
                                .subtract(1, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 3598,
                        },
                    ],
                },
            ],
            'last-year': [
                {
                    name: 'Visitors',
                    data: [
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2021,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 1749,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 1654,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1900,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 1647,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1315,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1807,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1793,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 1892,
                        },
                        {
                            x: now
                                .subtract(24, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1846,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 1804,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 1778,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 2015,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1892,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 1708,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1711,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1570,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1507,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 1451,
                        },
                        {
                            x: now
                                .subtract(23, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1522,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 1977,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2367,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 2798,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3080,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2856,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 2745,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2750,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 2728,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2436,
                        },
                        {
                            x: now
                                .subtract(22, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2289,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2804,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2777,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3024,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 2657,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2218,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1964,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1674,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1721,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2005,
                        },
                        {
                            x: now
                                .subtract(21, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1613,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 1071,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 1079,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 1133,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1536,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2016,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 2256,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1934,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1832,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2075,
                        },
                        {
                            x: now
                                .subtract(20, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1709,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 1831,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 1434,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 1293,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1064,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 1080,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1032,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1280,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1344,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 1835,
                        },
                        {
                            x: now
                                .subtract(19, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2287,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2692,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2250,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 1814,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1906,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 1973,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1882,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2333,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 2048,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2547,
                        },
                        {
                            x: now
                                .subtract(18, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2884,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2771,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2522,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 2543,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 2413,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2002,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1838,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1830,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1872,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2246,
                        },
                        {
                            x: now
                                .subtract(17, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2171,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2988,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2694,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 2806,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3040,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2898,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 3013,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2760,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3021,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2688,
                        },
                        {
                            x: now
                                .subtract(16, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2572,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2789,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 3069,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3142,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 3614,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 3202,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 2730,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2951,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 3267,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2882,
                        },
                        {
                            x: now
                                .subtract(15, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 2885,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 2915,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 2790,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 3071,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 2802,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 2382,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 1883,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 1448,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 1176,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 1275,
                        },
                        {
                            x: now
                                .subtract(14, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1136,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(1, 'days')
                                .toDate(),
                            y: 1160,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(4, 'days')
                                .toDate(),
                            y: 1524,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(7, 'days')
                                .toDate(),
                            y: 1305,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(10, 'days')
                                .toDate(),
                            y: 1725,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(13, 'days')
                                .toDate(),
                            y: 1850,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(16, 'days')
                                .toDate(),
                            y: 2304,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(19, 'days')
                                .toDate(),
                            y: 2187,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(22, 'days')
                                .toDate(),
                            y: 2597,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(25, 'days')
                                .toDate(),
                            y: 2246,
                        },
                        {
                            x: now
                                .subtract(13, 'months')
                                .add(28, 'days')
                                .toDate(),
                            y: 1767,
                        },
                    ],
                },
            ],
        },
    },
    conversions: {
        amount: 4123,
        labels: [
            now.subtract(47, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(40, 'days').format('DD MMM'),
            now.subtract(39, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(32, 'days').format('DD MMM'),
            now.subtract(31, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(24, 'days').format('DD MMM'),
            now.subtract(23, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(16, 'days').format('DD MMM'),
            now.subtract(15, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(8, 'days').format('DD MMM'),
            now.subtract(7, 'days').format('DD MMM') +
                ' - ' +
                now.format('DD MMM'),
        ],
        series: [
            {
                name: 'Conversions',
                data: [4412, 4345, 4541, 4677, 4322, 4123],
            },
        ],
    },
    impressions: {
        amount: 46085,
        labels: [
            now.subtract(31, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(24, 'days').format('DD MMM'),
            now.subtract(23, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(16, 'days').format('DD MMM'),
            now.subtract(15, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(8, 'days').format('DD MMM'),
            now.subtract(7, 'days').format('DD MMM') +
                ' - ' +
                now.format('DD MMM'),
        ],
        series: [
            {
                name: 'Impressions',
                data: [11577, 11441, 11544, 11523],
            },
        ],
    },
    visits: {
        amount: 62083,
        labels: [
            now.subtract(31, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(24, 'days').format('DD MMM'),
            now.subtract(23, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(16, 'days').format('DD MMM'),
            now.subtract(15, 'days').format('DD MMM') +
                ' - ' +
                now.subtract(8, 'days').format('DD MMM'),
            now.subtract(7, 'days').format('DD MMM') +
                ' - ' +
                now.format('DD MMM'),
        ],
        series: [
            {
                name: 'Visits',
                data: [15521, 15519, 15522, 15521],
            },
        ],
    },
    visitorsVsPageViews: {
        overallScore: 472,
        averageRatio: 45,
        predictedRatio: 55,
        series: [
            {
                name: 'Page Views',
                data: [
                    {
                        x: now.subtract(65, 'days').toDate(),
                        y: 4769,
                    },
                    {
                        x: now.subtract(64, 'days').toDate(),
                        y: 4901,
                    },
                    {
                        x: now.subtract(63, 'days').toDate(),
                        y: 4640,
                    },
                    {
                        x: now.subtract(62, 'days').toDate(),
                        y: 5128,
                    },
                    {
                        x: now.subtract(61, 'days').toDate(),
                        y: 5015,
                    },
                    {
                        x: now.subtract(60, 'days').toDate(),
                        y: 5360,
                    },
                    {
                        x: now.subtract(59, 'days').toDate(),
                        y: 5608,
                    },
                    {
                        x: now.subtract(58, 'days').toDate(),
                        y: 5272,
                    },
                    {
                        x: now.subtract(57, 'days').toDate(),
                        y: 5660,
                    },
                    {
                        x: now.subtract(56, 'days').toDate(),
                        y: 6026,
                    },
                    {
                        x: now.subtract(55, 'days').toDate(),
                        y: 5836,
                    },
                    {
                        x: now.subtract(54, 'days').toDate(),
                        y: 5659,
                    },
                    {
                        x: now.subtract(53, 'days').toDate(),
                        y: 5575,
                    },
                    {
                        x: now.subtract(52, 'days').toDate(),
                        y: 5474,
                    },
                    {
                        x: now.subtract(51, 'days').toDate(),
                        y: 5427,
                    },
                    {
                        x: now.subtract(50, 'days').toDate(),
                        y: 5865,
                    },
                    {
                        x: now.subtract(49, 'days').toDate(),
                        y: 5700,
                    },
                    {
                        x: now.subtract(48, 'days').toDate(),
                        y: 6052,
                    },
                    {
                        x: now.subtract(47, 'days').toDate(),
                        y: 5760,
                    },
                    {
                        x: now.subtract(46, 'days').toDate(),
                        y: 5648,
                    },
                    {
                        x: now.subtract(45, 'days').toDate(),
                        y: 5510,
                    },
                    {
                        x: now.subtract(44, 'days').toDate(),
                        y: 5435,
                    },
                    {
                        x: now.subtract(43, 'days').toDate(),
                        y: 5239,
                    },
                    {
                        x: now.subtract(42, 'days').toDate(),
                        y: 5452,
                    },
                    {
                        x: now.subtract(41, 'days').toDate(),
                        y: 5416,
                    },
                    {
                        x: now.subtract(40, 'days').toDate(),
                        y: 5195,
                    },
                    {
                        x: now.subtract(39, 'days').toDate(),
                        y: 5119,
                    },
                    {
                        x: now.subtract(38, 'days').toDate(),
                        y: 4635,
                    },
                    {
                        x: now.subtract(37, 'days').toDate(),
                        y: 4833,
                    },
                    {
                        x: now.subtract(36, 'days').toDate(),
                        y: 4584,
                    },
                    {
                        x: now.subtract(35, 'days').toDate(),
                        y: 4822,
                    },
                    {
                        x: now.subtract(34, 'days').toDate(),
                        y: 4330,
                    },
                    {
                        x: now.subtract(33, 'days').toDate(),
                        y: 4582,
                    },
                    {
                        x: now.subtract(32, 'days').toDate(),
                        y: 4348,
                    },
                    {
                        x: now.subtract(31, 'days').toDate(),
                        y: 4132,
                    },
                    {
                        x: now.subtract(30, 'days').toDate(),
                        y: 4099,
                    },
                    {
                        x: now.subtract(29, 'days').toDate(),
                        y: 3849,
                    },
                    {
                        x: now.subtract(28, 'days').toDate(),
                        y: 4010,
                    },
                    {
                        x: now.subtract(27, 'days').toDate(),
                        y: 4486,
                    },
                    {
                        x: now.subtract(26, 'days').toDate(),
                        y: 4403,
                    },
                    {
                        x: now.subtract(25, 'days').toDate(),
                        y: 4141,
                    },
                    {
                        x: now.subtract(24, 'days').toDate(),
                        y: 3780,
                    },
                    {
                        x: now.subtract(23, 'days').toDate(),
                        y: 3929,
                    },
                    {
                        x: now.subtract(22, 'days').toDate(),
                        y: 3524,
                    },
                    {
                        x: now.subtract(21, 'days').toDate(),
                        y: 3212,
                    },
                    {
                        x: now.subtract(20, 'days').toDate(),
                        y: 3568,
                    },
                    {
                        x: now.subtract(19, 'days').toDate(),
                        y: 3800,
                    },
                    {
                        x: now.subtract(18, 'days').toDate(),
                        y: 3796,
                    },
                    {
                        x: now.subtract(17, 'days').toDate(),
                        y: 3870,
                    },
                    {
                        x: now.subtract(16, 'days').toDate(),
                        y: 3745,
                    },
                    {
                        x: now.subtract(15, 'days').toDate(),
                        y: 3751,
                    },
                    {
                        x: now.subtract(14, 'days').toDate(),
                        y: 3310,
                    },
                    {
                        x: now.subtract(13, 'days').toDate(),
                        y: 3509,
                    },
                    {
                        x: now.subtract(12, 'days').toDate(),
                        y: 3311,
                    },
                    {
                        x: now.subtract(11, 'days').toDate(),
                        y: 3187,
                    },
                    {
                        x: now.subtract(10, 'days').toDate(),
                        y: 2918,
                    },
                    {
                        x: now.subtract(9, 'days').toDate(),
                        y: 3191,
                    },
                    {
                        x: now.subtract(8, 'days').toDate(),
                        y: 3437,
                    },
                    {
                        x: now.subtract(7, 'days').toDate(),
                        y: 3291,
                    },
                    {
                        x: now.subtract(6, 'days').toDate(),
                        y: 3317,
                    },
                    {
                        x: now.subtract(5, 'days').toDate(),
                        y: 3716,
                    },
                    {
                        x: now.subtract(4, 'days').toDate(),
                        y: 3260,
                    },
                    {
                        x: now.subtract(3, 'days').toDate(),
                        y: 3694,
                    },
                    {
                        x: now.subtract(2, 'days').toDate(),
                        y: 3598,
                    },
                    {
                        x: now.subtract(1, 'days').toDate(),
                        y: 3812,
                    },
                ],
            },
            {
                name: 'Visitors',
                data: [
                    {
                        x: now.subtract(65, 'days').toDate(),
                        y: 1654,
                    },
                    {
                        x: now.subtract(64, 'days').toDate(),
                        y: 1900,
                    },
                    {
                        x: now.subtract(63, 'days').toDate(),
                        y: 1647,
                    },
                    {
                        x: now.subtract(62, 'days').toDate(),
                        y: 1315,
                    },
                    {
                        x: now.subtract(61, 'days').toDate(),
                        y: 1807,
                    },
                    {
                        x: now.subtract(60, 'days').toDate(),
                        y: 1793,
                    },
                    {
                        x: now.subtract(59, 'days').toDate(),
                        y: 1892,
                    },
                    {
                        x: now.subtract(58, 'days').toDate(),
                        y: 1846,
                    },
                    {
                        x: now.subtract(57, 'days').toDate(),
                        y: 1966,
                    },
                    {
                        x: now.subtract(56, 'days').toDate(),
                        y: 1804,
                    },
                    {
                        x: now.subtract(55, 'days').toDate(),
                        y: 1778,
                    },
                    {
                        x: now.subtract(54, 'days').toDate(),
                        y: 2015,
                    },
                    {
                        x: now.subtract(53, 'days').toDate(),
                        y: 1892,
                    },
                    {
                        x: now.subtract(52, 'days').toDate(),
                        y: 1708,
                    },
                    {
                        x: now.subtract(51, 'days').toDate(),
                        y: 1711,
                    },
                    {
                        x: now.subtract(50, 'days').toDate(),
                        y: 1570,
                    },
                    {
                        x: now.subtract(49, 'days').toDate(),
                        y: 1507,
                    },
                    {
                        x: now.subtract(48, 'days').toDate(),
                        y: 1451,
                    },
                    {
                        x: now.subtract(47, 'days').toDate(),
                        y: 1522,
                    },
                    {
                        x: now.subtract(46, 'days').toDate(),
                        y: 1801,
                    },
                    {
                        x: now.subtract(45, 'days').toDate(),
                        y: 1977,
                    },
                    {
                        x: now.subtract(44, 'days').toDate(),
                        y: 2367,
                    },
                    {
                        x: now.subtract(43, 'days').toDate(),
                        y: 2798,
                    },
                    {
                        x: now.subtract(42, 'days').toDate(),
                        y: 3080,
                    },
                    {
                        x: now.subtract(41, 'days').toDate(),
                        y: 2856,
                    },
                    {
                        x: now.subtract(40, 'days').toDate(),
                        y: 2745,
                    },
                    {
                        x: now.subtract(39, 'days').toDate(),
                        y: 2750,
                    },
                    {
                        x: now.subtract(38, 'days').toDate(),
                        y: 2728,
                    },
                    {
                        x: now.subtract(37, 'days').toDate(),
                        y: 2436,
                    },
                    {
                        x: now.subtract(36, 'days').toDate(),
                        y: 2289,
                    },
                    {
                        x: now.subtract(35, 'days').toDate(),
                        y: 2657,
                    },
                    {
                        x: now.subtract(34, 'days').toDate(),
                        y: 2804,
                    },
                    {
                        x: now.subtract(33, 'days').toDate(),
                        y: 2777,
                    },
                    {
                        x: now.subtract(32, 'days').toDate(),
                        y: 3024,
                    },
                    {
                        x: now.subtract(31, 'days').toDate(),
                        y: 2657,
                    },
                    {
                        x: now.subtract(30, 'days').toDate(),
                        y: 2218,
                    },
                    {
                        x: now.subtract(29, 'days').toDate(),
                        y: 1964,
                    },
                    {
                        x: now.subtract(28, 'days').toDate(),
                        y: 1674,
                    },
                    {
                        x: now.subtract(27, 'days').toDate(),
                        y: 1721,
                    },
                    {
                        x: now.subtract(26, 'days').toDate(),
                        y: 2005,
                    },
                    {
                        x: now.subtract(25, 'days').toDate(),
                        y: 1613,
                    },
                    {
                        x: now.subtract(24, 'days').toDate(),
                        y: 1295,
                    },
                    {
                        x: now.subtract(23, 'days').toDate(),
                        y: 1071,
                    },
                    {
                        x: now.subtract(22, 'days').toDate(),
                        y: 799,
                    },
                    {
                        x: now.subtract(21, 'days').toDate(),
                        y: 1133,
                    },
                    {
                        x: now.subtract(20, 'days').toDate(),
                        y: 1536,
                    },
                    {
                        x: now.subtract(19, 'days').toDate(),
                        y: 2016,
                    },
                    {
                        x: now.subtract(18, 'days').toDate(),
                        y: 2256,
                    },
                    {
                        x: now.subtract(17, 'days').toDate(),
                        y: 1934,
                    },
                    {
                        x: now.subtract(16, 'days').toDate(),
                        y: 1832,
                    },
                    {
                        x: now.subtract(15, 'days').toDate(),
                        y: 2075,
                    },
                    {
                        x: now.subtract(14, 'days').toDate(),
                        y: 1709,
                    },
                    {
                        x: now.subtract(13, 'days').toDate(),
                        y: 1932,
                    },
                    {
                        x: now.subtract(12, 'days').toDate(),
                        y: 1831,
                    },
                    {
                        x: now.subtract(11, 'days').toDate(),
                        y: 1434,
                    },
                    {
                        x: now.subtract(10, 'days').toDate(),
                        y: 993,
                    },
                    {
                        x: now.subtract(9, 'days').toDate(),
                        y: 1064,
                    },
                    {
                        x: now.subtract(8, 'days').toDate(),
                        y: 618,
                    },
                    {
                        x: now.subtract(7, 'days').toDate(),
                        y: 1032,
                    },
                    {
                        x: now.subtract(6, 'days').toDate(),
                        y: 1280,
                    },
                    {
                        x: now.subtract(5, 'days').toDate(),
                        y: 1344,
                    },
                    {
                        x: now.subtract(4, 'days').toDate(),
                        y: 1835,
                    },
                    {
                        x: now.subtract(3, 'days').toDate(),
                        y: 2287,
                    },
                    {
                        x: now.subtract(2, 'days').toDate(),
                        y: 2226,
                    },
                    {
                        x: now.subtract(1, 'days').toDate(),
                        y: 2692,
                    },
                ],
            },
        ],
    },
    newVsReturning: {
        uniqueVisitors: 46085,
        series: [80, 20],
        labels: ['New', 'Returning'],
    },
    gender: {
        uniqueVisitors: 46085,
        series: [55, 45],
        labels: ['Male', 'Female'],
    },
    age: {
        uniqueVisitors: 46085,
        series: [35, 65],
        labels: ['Under 30', 'Over 30'],
    },
    language: {
        uniqueVisitors: 46085,
        series: [25, 75],
        labels: ['English', 'Other'],
    },
};
